import React, { memo, useContext } from 'react'
import LogoDark from '@/assets/images/logo-text-dark.png'
import LogoLight from '@/assets/images/logo-text-light.png'
import { SettingsContext } from '@/context/settings-context'

const Logo = memo(({ props }) => {
    const { theme } = useContext(SettingsContext)

    return (
        <img
            src={theme === 'dark' ? LogoDark : LogoLight}
            alt="Turba Media"
            style={{ maxHeight: '45px', height: 'auto', width: 'auto' }}
            {...props}
        />
    )
})

Logo.displayName = 'Logo'

export default Logo
